<template>
  <div class="row">
    <div class="col-md-10 col-md-12 ">
      <div class="card">
      <div class="card-header">
      </div>
      <div class="card-content row">
        <div class="col-sm-12">
          <div class="pull-left">
            <el-input v-model="filters[0].value" placeholder="Search" class="icon-search"></el-input>
          </div>
          <div class="pull-right">
            <router-link class="btn btn-info " title="Add Campaign" :to="{ path: '/marketing/campaigns/add'}"><i class="ti-plus"></i> {{$t('general.add')}} {{$t('marketingCampaigns.single')}}</router-link>
          </div>
        </div>
          <data-tables class=""
                    v-loading="loading"
                    :data="tableData"
                    :search-def="defaultSearchDef()"
                    :action-def="defaultActionDef()"
                    :pagination-def="paginationDef"
                    :table-props="{'border': false}" 
                    :filters="filters"
                    @row-click="goToRecord"
                    style="width: 100%">
            <el-table-column
              :min-width="40"
              :label="$t('marketingCampaigns.image')">
              <template slot-scope="props">
                <img v-bind:src="(props.row.image_url)?props.row.image_url[0].url : ''" />
              </template>
            </el-table-column> 
            <el-table-column
              :min-width="100"
              sortable
              prop="name"
              :label="$t('marketingCampaigns.name')">
            </el-table-column>
            <el-table-column
              :min-width="80"
              sortable
              prop="valid"
              :label="$t('marketingCampaigns.startEnd')">
              <template slot-scope="props">
                {{formatDate(props.row.datetime_validfrom)}} - {{formatDate(props.row.datetime_validto)}}
              </template>
            </el-table-column>
            <el-table-column
              :min-width="100"
              sortable
              prop="name"
              :label="$t('marketingCampaigns.daysLeft')">
              <template slot-scope="props">
                {{getDaysLeft(props.row.datetime_validto) }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('marketingCampaigns.status')"
              prop="active">
              <template slot-scope="props">
                <p-switch v-model="props.row.active" type="success" @input="handleActive(props.$index, props.row, $event)"></p-switch>
              </template>
            </el-table-column>
            <el-table-column
              :min-width="120"
              prop="actions"
              :label="$t('marketingCampaigns.actions')">
              <template slot-scope="props">
                <el-button  @click="handleDelete(props.$index, props.row)" >
                  {{$t('general.delete')}}
               </el-button>
               <el-button v-if="props.row.active && props.row.mode == 'MANUAL'" @click="sendNotif(props.$index, props.row)" >
                  {{$t('marketingCampaigns.send')}}
               </el-button>
              </template>
            </el-table-column>
            <el-table-column
              :width="45">
              <template slot-scope="props"><i class="fa fa-pencil"></i></template>
            </el-table-column>
          </data-tables>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Select, Option} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Input)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(DataTables)
  export default{
    components: {
      PPagination,
      PSwitch
    },
    watch: {
    },
    computed: {
    },
    data () {
      return {
        loading: true,
        actionCol: {
          label: 'Delete',
          props: {
            align: 'center'
          },
          buttons: [{
            props: {
              type: 'danger',
              icon: 'el-icon-delete',
              class: 'btn btn-orange btn-fill'
            },
            handler: (index, row) => {
              this.handleDelete(index, row)
            },
            label: this.$t('general.delete')
          }]
        },
        paginationDef: {
          pageSize: 10,
          currentPage: 1,
          pageSizes: [10, 25, 50],
          show: true
        },
        searchQuery: '',
        propsToSearch: ['name', 'status', 'type', 'discount'],
        tableColumns: [],
        tableData: [],
        filters: [
          {
            value: '',
            prop: ['name', 'status', 'type']
          }
        ]
      }
    },
    created: function () {
      var self = this
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/campaign', 'GET', data, function (response) {
        if (response.status === true) {
          self.tableData = response.data
        }
        self.$nextTick(function () {
          self.loading = false
        })
      })
    },
    methods: {
      goToRecord (row, event, column) {
        if (column.property !== 'actions' && column.property !== 'active') {
          this.globalGoToRecord(row, event, column, '/marketing/campaigns/edit/')
        }
      },
      handleActive (index, row, e) {
        let actionText = row.active ? this.$t('general.activate') : this.$t('general.deactivate')
        swal({
          text: this.$t('validations.areYouSureYouWantTo') + ` ${actionText} ${row.name}?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        }).then((result) => {
          if (result) {
            var data = {
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany'),
              // status: row.active ? 0 : 1,
              name: row.name,
              type: row.type,
              mode: row.mode,
              notification_type: row.notification_type[0].type,
              active: row.active ? 1 : 0
            }
            var self = this
            this.apiRequest('/campaign/' + row.id, 'PUT', data, function (response) {
              if (response.status) {
                swal(
                  self.$t('general.success') + '!',
                  '',
                  'success'
                ).catch(() => {})
              } else {
                swal(
                  '',
                  self.$t('validations.wentWrong'),
                  'error'
                ).catch(() => {})
                row.active = !row.active
              }
            })
          }
        }).catch(() => {
          row.active = !row.active
        })
      },
      sendNotif (index, row) {
        swal({
          text: this.$t('marketingCampaigns.areYouSureNotif'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        }).then((result) => {
          this.$nextTick(function () { this.loading = true })
          if (result) {
            var data = {
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany'),
              campaign_id: row.id
            }
            var self = this
            this.apiRequest('/queues/notifications', 'POST', data, function (response) {
              self.$nextTick(function () { this.loading = false })
              if (response.status) {
                swal(
                  '',
                  self.$t('marketingCampaigns.notifSent'),
                  'success'
                ).catch(() => {})
              } else {
                let msg = self.$t('validations.wentWrong')
                if (response.errors.campaign_id !== undefined) {
                  msg = response.errors.campaign_id
                }
                swal(
                  '',
                  msg,
                  'error'
                ).catch(() => {})
              }
            })
          }
        }).catch(() => {
         //
        })
      },
      handleDelete (index, row) {
        var self = this
        var btnCounter = 3
        swal({
          text: this.$t('marketingCampaigns.areYouSureDelete') + ' ' + row.name + '?',
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes') + ' (' + btnCounter + ')'
        })
        .then((result) => {
          if (result) {
            var data = {
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany')
            }
            this.apiRequest('/campaign/' + row.id, 'DELETE', data, function (response) {
              if (response.status === true) {
                swal(
                  '',
                  self.$t('marketingCampaigns.campaignDeleted'),
                  'success'
                ).catch(() => {})
                self.tableData.splice(index, 1)
              } else {
                swal(
                  '',
                  self.$t('validations.wentWrong'),
                  'error'
                ).catch(() => {})
              }
            })
          }
        }).catch(() => {
          //
        })
        swal.disableConfirmButton()
        var btnInterval = setInterval(function () {
          btnCounter--

          if (btnCounter >= 1) {
            swal.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')'
          } else {
            clearInterval(btnInterval)
            swal.getConfirmButton().textContent = self.$t('general.yes')
            swal.enableConfirmButton()
          }
        }, 1000)
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Campaigns/Campaigns.vue